import React, { useEffect, useState } from "react";
import { AddTopicModal } from "../AddTopicModal";
import { UserOutlined } from "@ant-design/icons";
import { api } from "services/api";
import Loading from "components/Loading";
import ReactQuill from "react-quill";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { Form, Modal } from "antd";

export const ViemForumModal = ({ ...props }) => {
	const { setIsOpen, isOpen, currentCourseData, isCourse } = props;
	const [topicsInfos, setTopicsInfos] = useState<any>();
	const [topicId, setTopicId] = useState<string>("");
	const [forumTopics, setForumTopics] = useState<any[]>();
	const [currentTopic, setCurrentTopic] = useState<any>();
	const [value, setValue] = useState<string>("");
	const [isOpenAddTopic, setIsOpenAddTopic] = useState<boolean>(false);
	const [courseForumId, setCourseForumId] = useState();
	const [form] = Form.useForm();

	const { id: userId } = useSelector((state: any) => state.app.user);

	const handleSendMessage = () => {
		api
			.post(`/topics/${topicId}/messages`, {
				id_topico: topicId,
				text: value,
				user_id: userId,
				is_active: true,
			})
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					api.get(`/topics/${topicId}/messages`).then((res) => {
						setTopicsInfos(res.data.data);
					});
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						setValue("");
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		const loadData = async () => {
			if (userId && currentCourseData.id) {
				switch (isCourse) {
					case true:
						await api
							.get(`/courses/${currentCourseData.id}/modules/users/${userId}`)
							.then(async (res) => {
								await api
									.get(`/forums/${res?.data?.data?.forum?.id}/topics`)
									.then((r) => {
										setForumTopics(r.data.data.topics);
									});

								setCourseForumId(res?.data?.data?.forum?.id);
							});
						break;
					case false:
						await api
							.get(`/forums/${currentCourseData.forum.id}/topics`)
							.then((r) => {
								setForumTopics(r.data.data.topics);
							});

						setCourseForumId(currentCourseData.forum.id);
						break;
				}
			}
		};

		loadData();
		// eslint-disable-next-line
	}, [userId, currentCourseData]);
	return (
		<Modal
			title={
				<p style={{ margin: 0 }}>
					Visualizar fórum {isCourse ? "do curso" : "da aula"} -{" "}
					{currentCourseData?.title}
				</p>
			}
			open={isOpen}
			maskClosable={false}
			footer={false}
			onCancel={() => {
				setIsOpen(!isOpen);
			}}
			className="modal-users"
		>
			<div className="class-module" style={{ width: "80vw" }}>
				<AddTopicModal
					setIsOpen={setIsOpenAddTopic}
					isOpen={isOpenAddTopic}
					forumId={courseForumId}
					form={form}
					setForumTopics={setForumTopics}
				/>
				<div
					className="class-module__container"
					style={{ marginTop: 0, padding: 0 }}
				>
					<div
						className="class-module__container__info"
						style={{ height: "615px" }}
					>
						<>
							<div className="class-module__container__info__forum-topics__header">
								<h1 className="class-module__container__info__forum-topics__header__title">
									Fórum de dúvidas
								</h1>
								<button
									className="class-module__container__info__forum-topics__header__btn"
									onClick={() => setIsOpenAddTopic(!isOpenAddTopic)}
								>
									Criar tópico
								</button>
							</div>
							<div className="class-module__container__info__forum-topics">
								{forumTopics &&
									forumTopics.map((module: any, index: number) => {
										const { id, created_at } = module;
										return (
											<div
												key={index}
												className="class-module__container__info__forum-topics__topic"
												style={{ cursor: "pointer" }}
												onClick={() => {
													setTopicId(id);
													api.get(`/topics/${id}/messages`).then((res) => {
														setTopicsInfos(res.data.data);
													});
													setCurrentTopic(module);
												}}
											>
												<div className="class-module__container__info__forum-topics__topic__img">
													<UserOutlined twoToneColor="#000" />
												</div>
												<div className="info">
													<h1 className="class-module__container__info__forum-topics__topic__title">
														{module.subject}
													</h1>
													<div
														style={{
															display: "flex",
															flexDirection: "row",
															justifyContent: "space-between",
															width: "100%",
														}}
													>
														<p>Nome do criador do tópico</p>
														<p>{created_at}</p>
													</div>
												</div>
											</div>
										);
									})}

								{!forumTopics && (
									<div
										style={{
											height: "100%",
											width: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										<Loading title="Tópicos" />
									</div>
								)}

								{forumTopics && !forumTopics?.length && (
									<p
										style={{
											height: "100%",
											width: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										Não há tópicos disponíveis.
									</p>
								)}
							</div>
						</>
					</div>

					<div className="class-module__container__forum">
						<div className="class-module__container__forum__topics-container">
							{topicsInfos?.messages && (
								<h1 className="module__container__lesson__module-title">
									Tópico atual: {currentTopic?.subject}
								</h1>
							)}
							{!topicsInfos?.messages && (
								<p
									style={{
										height: "100%",
										width: "100%",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									Selecione um tópico para visualizar suas respectivas
									mensagens.
								</p>
							)}
							{topicsInfos?.messages?.length === 0 && (
								<p
									style={{
										height: "100%",
										width: "100%",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									Ainda não há mensagens para exibir nesse tópico.
								</p>
							)}
							{topicsInfos?.messages.map(
								(
									{ message, user }: { message: any; user: any },
									index: number
								) => {
									return (
										<div
											key={index}
											className="class-module__container__forum__topics-container__topic"
										>
											<div className="class-module__container__forum__topics-container__topic__img">
												<UserOutlined twoToneColor="#000" />
											</div>
											<div className="info">
												<h1
													style={{
														textTransform: "capitalize",
														margin: 0,
														lineHeight: "12px",
													}}
												>
													{user[0]?.username}
												</h1>
												<p style={{ fontWeight: "100" }}>
													Criado em: {message.created_at}
												</p>
												<div
													dangerouslySetInnerHTML={{
														__html: `<p>${message.text}</p>`,
													}}
												></div>
											</div>
										</div>
									);
								}
							)}
						</div>

						{topicsInfos?.messages && (
							<>
								<div className="class-module__container__forum__input">
									<ReactQuill theme="snow" value={value} onChange={setValue} />
								</div>
							</>
						)}
						<div className="class-module__container__forum__btns">
							<button style={{ display: "none" }}></button>

							{topicsInfos?.messages && (
								<button onClick={() => handleSendMessage()}>Enviar</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};
